import { I18n } from 'i18n-js';
import TextUtils from './textUtils';
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/tl-ph';

import en from './translations/en.json';
import es from './translations/es.json';
import tl from './translations/tl.json';

const i18n = new I18n({
  en,
  es,
  tl,
});

i18n.defaultLocale = 'en-US';
i18n.enableFallback = true;

const MOMENT_LOCALES = {
  'en-us': 'en',
  'es-es': 'es',
  'tl-ph': 'tl-ph',
};

let employerUIConfig = null;

function _fixupStringForEmployer(text) {
  const terms = employerUIConfig?.terms;
  const configSingular = terms?.residentSingular;
  const configPlural = terms?.residentPlural;

  if (!configSingular || !configPlural) return text;

  const residentSingular = i18n.t('employer.resident');
  const translatedSingular = i18n.t(`employer.${configSingular}`);

  const residentPlural = i18n.t('employer.residents');
  const translatedPlural = i18n.t(`employer.${configPlural}`);

  text = text.replace(residentPlural, translatedPlural);
  text = text.replace(TextUtils.c1(residentPlural), TextUtils.c1(translatedPlural));
  text = text.replace(residentSingular, translatedSingular);
  text = text.replace(TextUtils.c1(residentSingular), TextUtils.c1(translatedSingular));

  return text;
}

const customI18n = {
  t: (key, params) => i18n.t(key, params),

  setPreferredLocale: (locale) => {
    if (!locale) return;

    i18n.locale = locale;
    const momentLocale = MOMENT_LOCALES[locale.toLowerCase()];
    moment.locale([momentLocale, 'en']);
  },

  setEmplopyerUIConfig: (uiConfig) => {
    if (!uiConfig?.terms) return;
    employerUIConfig = uiConfig;
  },

  /** Capitalize the first letter of the retrieved localized string. */
  capitalizeFirst: (key, params = null, applyEmployerConfig = false) => {
    let text = i18n.t(key, params);
    if (applyEmployerConfig) text = _fixupStringForEmployer(text);
    return TextUtils._capitalizeWord(text);
  },

  c1: (key, params = null, applyEmployerConfig = false) => {
    return customI18n.capitalizeFirst(key, params, applyEmployerConfig);
  },

  c1_aec: (key, params = null) => {
    return customI18n.c1(key, params, true);
  },

  /** Capitalize all letters of the retrieved localized string. */
  allCaps: (key, params = null, applyEmployerConfig = false) => {
    let text = i18n.t(key, params);
    if (applyEmployerConfig) text = _fixupStringForEmployer(text.toLowerCase());
    return TextUtils.allCaps(text);
  },

  ac: (key, params = null, applyEmployerConfig = false) => {
    return customI18n.allCaps(key, params, applyEmployerConfig);
  },

  ac_aec: (key, params = null) => {
    return customI18n.allCaps(key, params, true);
  },

  capitalizeEach: (key, params = null, applyEmployerConfig = false) => {
    let text = i18n.t(key, params);
    if (applyEmployerConfig) text = _fixupStringForEmployer(text);
    return TextUtils.ce(text);
  },

  ce: (key, params = null, applyEmployerConfig = false) => {
    return customI18n.capitalizeEach(key, params, applyEmployerConfig);
  },

  ce_aec: (key, params = null) => {
    return customI18n.capitalizeEach(key, params, true);
  },

  applyEmployerConfig: (key, params = null) => {
    let text = i18n.t(key, params);
    return _fixupStringForEmployer(text);
  },

  aec: (key, params = null) => {
    return customI18n.applyEmployerConfig(key, params);
  },
};

export default customI18n;
